<template>
  <div class="bus-filter">
    <div class="filter-header">
      <div class="filter-title">
        <span class="material-symbols-outlined">filter_list</span>
        <span>Filter Routes</span>
      </div>
      <button
        @click="$emit('refresh')"
        class="refresh-btn"
        :class="{ 'refreshing': refreshing }"
        :disabled="refreshing"
      >
        <span class="material-symbols-outlined">refresh</span>
        <span>{{ refreshing ? 'Refreshing...' : 'Refresh' }}</span>
      </button>
    </div>
    
    <div class="filter-controls">
      <div class="filter-group">
        <label for="campus" class="filter-label">
          <span class="material-symbols-outlined">school</span>
          <span>Campus</span>
        </label>
        <div class="select-wrapper">
          <select
            id="campus"
            v-model="selectedCampusValue"
            class="filter-select"
            @change="onCampusChange"
          >
            <option value="">All Campuses</option>
            <option v-for="campus in campuses" :key="campus" :value="campus">{{ campus }}</option>
          </select>
          <span class="material-symbols-outlined select-icon">expand_more</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BusFilter',
  props: {
    campuses: {
      type: Array,
      required: true
    },
    selectedCampus: {
      type: String,
      default: ''
    },
    refreshing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedCampusValue: this.selectedCampus
    };
  },
  watch: {
    selectedCampus(newValue) {
      this.selectedCampusValue = newValue;
    }
  },
  methods: {
    onCampusChange() {
      this.$emit('update:selectedCampus', this.selectedCampusValue);
    }
  }
};
</script>

<style scoped>
.bus-filter {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.filter-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  font-size: 1.125rem;
  color: #1f2937;
}

.filter-title .material-symbols-outlined {
  color: #3b82f6;
  font-size: 24px;
}

.refresh-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
}

.refresh-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
}

.refresh-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.refresh-btn.refreshing .material-symbols-outlined {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.filter-controls {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.filter-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filter-label .material-symbols-outlined {
  color: #3b82f6;
  font-size: 18px;
}

.select-wrapper {
  position: relative;
}

.filter-select {
  width: 100%;
  padding: 0.75rem 3rem 0.75rem 1rem;
  background: #f9fafb;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #1f2937;
  cursor: pointer;
  transition: all 0.2s ease;
  appearance: none;
}

.filter-select:hover {
  border-color: #cbd5e1;
}

.filter-select:focus {
  outline: none;
  border-color: #3b82f6;
  background: white;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.select-icon {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  pointer-events: none;
  font-size: 24px;
}

@media (max-width: 640px) {
  .bus-filter {
    padding: 1.25rem;
  }

  .filter-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .refresh-btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
